import { useEffect, useState } from 'react'
import { GetPendingCorrections, HasClosedCorrections } from '../redux/actions/studentCorrectionsAction'

/**
 * Whether this learner has any correction at all, which is what puts the
 * Corrections link in front of a learner who is not on Pro: the free correction,
 * or a Pro who downgraded. With `withPending`, a learner with nothing finished is
 * also asked about work still with the teacher.
 *
 * Asks once per mount. Telling the learner a correction came back is the
 * notifications bell's job (a `correction_ready` notification from the server).
 */
export const useHasCorrections = (
  memberId: string | undefined,
  enabled: boolean,
  { withPending = false }: { withPending?: boolean } = {},
): boolean => {
  const [hasCorrections, setHasCorrections] = useState(false)

  useEffect(() => {
    setHasCorrections(false)
    if (!enabled || !memberId) return

    let cancelled = false
    HasClosedCorrections()
      .then((closed) => {
        if (cancelled) return
        if (closed || !withPending) {
          setHasCorrections(closed)
          return
        }
        return GetPendingCorrections().then((pending) => !cancelled && setHasCorrections(pending.length > 0))
      })
      // A failed request must cost the header nothing.
      .catch(() => undefined)

    return () => {
      cancelled = true
    }
  }, [enabled, memberId, withPending])

  return hasCorrections
}

export default useHasCorrections
